import { Typography } from "@mui/material"
import { Box } from "@mui/system"
import { Loader } from "components/Loader"
import { useSessionsContext } from "layouts/sessions/context/sessions-context"
import { SessionsHeader } from "layouts/sessions/header"
import { SessionsTable } from "layouts/sessions/table/SessionsTable"
import {ConnexionError} from "components/ConnexionError.tsx";

export const SessionsContainer = () => {
    const { isLoading, noResultFilter, apiSuccess  } = useSessionsContext()

    if (isLoading && apiSuccess == null)
        return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Loader />
            </Box>
        )

    if (!apiSuccess)
        return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <ConnexionError />
            </Box>
        )

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
            }}
        >
            <SessionsHeader />
            {noResultFilter ? (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography sx={{ color: "grey.600" }}>
                        Aucun résultat
                    </Typography>
                </Box>
            ) : (
                <SessionsTable />
            )}
        </Box>
    )
}
